module.exports = __webpack_public_path__ + "img/product16-NDW.4fe85b74.svg";